module.exports = __webpack_public_path__ + "img/sophie.1ccd0129.png";